import { CursorArrowIcon, GroupIcon } from '@radix-ui/react-icons'
import * as Toggle from '@radix-ui/react-toggle-group'
import PolygonSelectIcon from 'assets/polygon-select.svg?react'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { CreateCameraViewButton } from 'features/kestrelViewer/ui/tools/CreateCameraViewButton'
import { KestrelViewerTool } from 'features/kestrelViewer/ui/tools/KestrelViewerTool'
import { MeasurementModes } from 'features/kestrelViewer/ui/tools/MeasurementModes'
import React from 'react'

export const PrimaryModes: React.FC = () => {
  const { sendCommand, selectedMode, setSelectedMode } =
    useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrelViewerContext()

  return (
    <Toggle.Root
      type='single'
      value={selectedMode}
      aria-label='Change mode'
      onClick={(event) => event.stopPropagation()}
      onValueChange={(value) => {
        if (value === '') return
        setSelectedMode(value)
        sendCommand({ command: 'setMode', mode: value })
        trackButtonClicked({
          button_name: `kestrel_set_mode`,
          kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          mode: value,
        })
      }}>
      <KestrelViewerTool
        tooltipLabel={'Select'}
        modeId={'cursor'}
        selectedMode={selectedMode}>
        <CursorArrowIcon width={20} height={20} />
      </KestrelViewerTool>
      <KestrelViewerTool
        tooltipLabel={'Draw Inspection Areas'}
        modeId={'polygon'}
        selectedMode={selectedMode}>
        <PolygonSelectIcon width={25} height={25} />
      </KestrelViewerTool>
      <KestrelViewerTool
        tooltipLabel={'Draw Surface Areas'}
        modeId={'surfaceArea'}
        selectedMode={selectedMode}>
        <GroupIcon width={25} height={25} />
      </KestrelViewerTool>
      <MeasurementModes />
      <CreateCameraViewButton />
    </Toggle.Root>
  )
}
